/* eslint-disable @typescript-eslint/no-explicit-any */
import type {
  IOptionsSkeleton,
  IColStyles
} from '@/modules/Core/interfaces/generales/IGenerales'
import type { IFiltersOptions } from '@/modules/Core/interfaces/generales/IFiltersOptions'
import type { AxiosError } from 'axios'
import type {
  ICitaFormxtab,
  ICitaTechnologiasSalud,
  IEstructuraOdontograma
} from '@/modules/Asistencial/interfaces'
import type {
  IDispAgendas,
  IDispHoras,
  ITurnos
} from '@/modules/Agendamiento/interfaces'
import type {
  IConfCalendarioAdmin,
  IConfComponents,
  IConfCompxfuncion,
  IConfFormxtab,
  IFormComponent
} from '@/modules/Administracion/interfaces'
import type { ICitaTabxcomponents } from '@/modules/Asistencial/interfaces'
import {
  maestraService
} from '@/services'
import { openModalById, closeModalById } from '@/modules/Core/composables/useModal'

import type { ICitaAdmision } from '@/modules/Admision/interfaces'
import type { IConfEntidades, IConfMaestra } from '@/modules/Configuracion/interfaces'
import type { IConfTarifarios } from '@/modules/Contratacion/interfaces'
import type { IAuthItemChild, IUserLoged } from '@/modules/Autenticacion/interfaces'
import type {
  IFormxtab
} from '@/modules/Configuracion/interfaces/IFormComponent'


import ExcelJS from 'exceljs'
import FileSaver from 'file-saver'
import type { IExportOptionsAtenciones } from '../interfaces/generales/IExportExcel'
import type { tipoImpresionAsistencialDefault } from './constantes'
import { ADMISSION_TYPE } from './constantes'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)


const permisos = () =>
  JSON.parse(localStorage?.getItem('permisos')?.toString() || '[]')
const roles = () =>
  JSON.parse(localStorage?.getItem('roles')?.toString() || '[]') as string[]
const listaIPS = JSON.parse(
  localStorage?.getItem('entidades')?.toString() || '[]'
)

export { permisos, listaIPS }
export function getImgUrl(img: string) {
  return new URL(img, import.meta.url).href
}
export const dominio = window.location.origin
export function getMaestra(id: number, maestra: Array<IConfMaestra>) {
  if (id != null) {
    if (maestra.length > 0) {
      const ma = maestra.filter(e => e.comaId == id)
      if (ma.length > 0) {
        const m = ma[0]
        return m.comaNombrecorto
      }
    }
  }
}

export function getMaestraName(id: string, maestra: Array<IConfMaestra>) {
  if (id != null) {
    if (maestra.length > 0) {
      const ma = maestra.filter(e => e.comaNombrecorto == id)
      if (ma.length > 0) {
        const m = ma[0]
        return m.comaId
      }
    }
  }
}

export function getValorcup(
  codigo: Array<IConfTarifarios>,
  porcentaje: string,
  signo: string,
  cantidad: string,
  tipotarifario: number,
  salariominimo: string
) {
  const tarifario = codigo.filter(e => e.cotaTipoTarifario == tipotarifario)[0]
  let valorneto = 0
  if (tarifario) {
    if (parseInt(tarifario.cotaValor as string) < 900) {
      const valorpleno =
        (parseInt(salariominimo) / 30) *
        parseFloat(tarifario.cotaValor as string)
      if (porcentaje && signo) {
        if (signo == 'POSITIVO') {
          valorneto =
            valorpleno +
            valorpleno * parseFloat((parseInt(porcentaje) / 100).toString())
        } else {
          valorneto =
            valorpleno -
            valorpleno * parseFloat((parseInt(porcentaje) / 100).toString())
        }
      } else {
        if (cantidad) {
          valorneto = valorpleno * parseInt(cantidad)
        } else {
          valorneto = valorpleno
        }
      }
    } else {
      if (cantidad) {
        return parseInt(tarifario.cotaValor as string) * parseInt(cantidad)
      } else {
        return parseInt(tarifario.cotaValor as string)
      }
    }
  } else {
    return 0
  }

  return Math.round(valorneto)
}

export function validatePermiso(p_permisos: string[]) {
  if (validateRole([])) {
    return true
  }
  return p_permisos.some(p =>
    permisos().some((e: IAuthItemChild) => e.child == p)
  )
}
export function validateRole(rols: string[]) {
  return ['SUPERADMIN', ...rols].some(e =>
    roles().some(a => a == e)
  )
}
export function filtrar(
  filtros: Array<IFiltersOptions>,
  page: number,
  limit: number | string = 10
) {
  const calculoLimit = typeof limit === 'string' ? 1 : limit
  let search = {
    offset: (page - 1) * calculoLimit,
    limit: limit
  }
  filtros.forEach((filtro: IFiltersOptions) => {
    if (
      filtro.value != null &&
      filtro.value.toString().replace(/ /g, '') != ''
    ) {
      /*if (filtro.type == 'date-range') {
        if (filtro.value[0]) {
          search = {
            ...search,
            [filtro.campo
              ? filtro.campo
              : filtro.name]: `${filtro.value[0]},${filtro.value[1] ? filtro.value[1]:filtro.value[0]}`
          }
        }
      } else { */
      search = {
        ...search,
        [filtro.campo ? filtro.campo : filtro.name]: filtro.value
      }
      //}
    }
  })
  return search
}
export function datediff(date1: Date, date2: Date) {
  let y1 = date1.getFullYear(),
    m1 = date1.getMonth(),
    d1 = date1.getDate()
  const y2 = date2.getFullYear(),
    m2 = date2.getMonth(),
    d2 = date2.getDate()
  if (d1 < d2) {
    m1--
    const date = new Date(y2, m2, 1, 12)
    date.setDate(0)
    d1 += date.getDate()
  }
  if (m1 < m2) {
    y1--
    m1 += 12
  }
  return [y1 - y2, m1 - m2, d1 - d2]
}
export function calcularEdad(fecha: string, desde?: string) {
  const [fy, fm, fd] = (desde ?? new Date().toISOString().slice(0, 10)).split('-')

  const ahora_ano = Number(fy)
  const ahora_mes = Number(fm) - 1
  const ahora_dia = Number(fd)
  const [ano, mes, dia] = fecha.split('-').map(Number)

  const curd = new Date(ahora_ano, ahora_mes, ahora_dia)
  const cald = new Date(ano, mes - 1, dia)

  const dife = datediff(curd, cald)

  return `${dife[0]} años, ${dife[1]} meses y ${dife[2]} días`
}

/**
 * Valida si la fecha es un dia habil
 * @param date Fecha a validar
 * @returns booleano
 */
export function isAllowedDate(date: string) {
  return (
    new Date(date.replace(/-+/g, '/')).getDay() != 0 &&
    new Date(date.replace(/-+/g, '/')).getDay() != 6
  )
}
export function getNextAllowedDate(date: Date) {
  const fecha = date
  if (isAllowedDate(fecha.yyyymmdd())) {
    return fecha.yyyymmdd()
  } else {
    fecha.setDate(fecha.getDate() + 1)
    return getNextAllowedDate(fecha)
  }
}
export function appendLeadingZeroes(n: number) {
  if (n <= 9) {
    return '0' + n
  }
  return n
}

export function openModal(
  id: string,
  isClosable: boolean = false,
  callBack?: () => void
) {
  return openModalById(id, isClosable, callBack)
}

export function closeModal(id: string, fncAux?: (() => void) | null) {
  return closeModalById(id, fncAux ?? undefined)
}
export const colorTipos = {
  PROCEDIMIENTO:
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-blue-50 text-blue-600 ring-1 ring-inset ring-blue-600/10 dark:bg-blue-400/10 dark:text-blue-400 dark:ring-blue-400/20',
  LABORATORIO:
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-teal-50 text-teal-600 ring-1 ring-inset ring-teal-600/10 dark:bg-teal-400/10 dark:text-teal-400 dark:ring-teal-400/20',
  CONSULTA:
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-sky-50 text-sky-600 ring-1 ring-inset ring-sky-600/10 dark:bg-sky-400/10 dark:text-sky-400 dark:ring-sky-400/20',
  HOSPITALIZACION:
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-red-50 text-red-600 ring-1 ring-inset ring-red-600/10 dark:bg-red-400/10 dark:text-red-400 dark:ring-red-400/20',
  URGENCIA:
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-amber-50 text-amber-600 ring-1 ring-inset ring-amber-600/10 dark:bg-amber-400/10 dark:text-amber-400 dark:ring-amber-400/20',
  TRIAGE:
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-yellow-50 text-yellow-600 ring-1 ring-inset ring-yellow-600/10 dark:bg-yellow-400/10 dark:text-yellow-400 dark:ring-yellow-400/20',
  VACUNA:
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-indigo-50 text-indigo-600 ring-1 ring-inset ring-indigo-600/10 dark:bg-indigo-400/10 dark:text-indigo-400 dark:ring-indigo-400/20'
} as Record<string, string>

export const colorEstadosMed = {
  'EN EXISTENCIA':
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-green-50 text-green-600 ring-1 ring-inset ring-green-600/10 dark:bg-green-400/10 dark:text-green-400 dark:ring-green-400/20',
  'PRONTO A AGOTARSE':
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-amber-50 text-amber-600 ring-1 ring-inset ring-amber-600/10 dark:bg-amber-400/10 dark:text-amber-400 dark:ring-amber-400/20',
  AGOTADO:
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-rose-50 text-rose-600 ring-1 ring-inset ring-rose-600/10 dark:bg-rose-400/10 dark:text-rose-400 dark:ring-rose-400/20'
} as Record<string, string>

export const cuentaComoOcupado = (estado?: string | null): boolean =>
  !!estado && (Object.values(ADMISSION_TYPE) as string[]).includes(estado)

export const colorEstados = {
  AGENDADO:
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-sky-50 text-sky-700 ring-1 ring-inset ring-sky-700/10 dark:bg-sky-400/10 dark:text-sky-400 dark:ring-sky-400/20',
  ADMISIONADO:
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-amber-50 text-amber-600 ring-1 ring-inset ring-amber-600/10 dark:bg-amber-400/10 dark:text-amber-400 dark:ring-amber-400/20',
  'ABIERTO':
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-emerald-50 text-emerald-600 ring-1 ring-inset ring-emerald-600/10 dark:bg-emerald-400/10 dark:text-emerald-400 dark:ring-emerald-400/20',
  CANCELADO:
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-rose-50 text-rose-600 ring-1 ring-inset ring-rose-600/10 dark:bg-rose-400/10 dark:text-rose-400 dark:ring-rose-400/20',
  FINALIZADO:
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-green-50 text-green-600 ring-1 ring-inset ring-green-600/10 dark:bg-green-400/10 dark:text-green-400 dark:ring-green-400/20',
  REAGENDADO:
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-violet-50 text-violet-600 ring-1 ring-inset ring-violet-600/10 dark:bg-violet-400/10 dark:text-violet-400 dark:ring-violet-400/20',
  'NO REALIZADO':
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-gray-50 text-gray-600 ring-1 ring-inset ring-gray-600/10 dark:bg-gray-400/10 dark:text-gray-400 dark:ring-gray-400/20',
  TRAMITADO:
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-green-50 text-green-600 ring-1 ring-inset ring-green-600/10 dark:bg-green-400/10 dark:text-green-400 dark:ring-green-400/20',
  'TRAMITADO CON ANEXO':
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-blue-50 text-blue-600 ring-1 ring-inset ring-blue-600/10 dark:bg-blue-400/10 dark:text-blue-400 dark:ring-blue-400/20',
  INASISTIDO:
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-gray-50 text-gray-600 ring-1 ring-inset ring-gray-600/10 dark:bg-gray-400/10 dark:text-gray-400 dark:ring-gray-400/20'
} as Record<string, string>

export const colorActivoEstados = {
  ACTIVO:
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-green-50 text-green-600 ring-1 ring-inset ring-green-600/10 dark:bg-green-400/10 dark:text-green-400 dark:ring-green-400/20',
  INACTIVO:
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-rose-50 text-rose-600 ring-1 ring-inset ring-rose-600/10 dark:bg-rose-400/10 dark:text-rose-400 dark:ring-rose-400/20',
  DEFAULT:
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-gray-50 text-gray-600 ring-1 ring-inset ring-gray-600/10 dark:bg-gray-400/10 dark:text-gray-400 dark:ring-gray-400/20',
  1: 'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-green-50 text-green-600 ring-1 ring-inset ring-green-600/10 dark:bg-green-400/10 dark:text-green-400 dark:ring-green-400/20',
  0: 'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-rose-50 text-rose-600 ring-1 ring-inset ring-rose-600/10 dark:bg-rose-400/10 dark:text-rose-400 dark:ring-rose-400/20',
  true: 'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-green-50 text-green-600 ring-1 ring-inset ring-green-600/10 dark:bg-green-400/10 dark:text-green-400 dark:ring-green-400/20',
  false:
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-rose-50 text-rose-600 ring-1 ring-inset ring-rose-600/10 dark:bg-rose-400/10 dark:text-rose-400 dark:ring-rose-400/20',
  FINALIZADO:
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-green-50 text-green-600 ring-1 ring-inset ring-green-600/10 dark:bg-green-400/10 dark:text-green-400 dark:ring-green-400/20',
  'ABIERTO':
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-amber-50 text-amber-600 ring-1 ring-inset ring-amber-600/10 dark:bg-amber-400/10 dark:text-amber-400 dark:ring-amber-400/20',
  'INGRESO NUEVO':
    'inline-flex items-center gap-x-1.5 px-2.5 py-1 rounded-md text-xs font-medium bg-green-50 text-green-600 ring-1 ring-inset ring-green-600/10 dark:bg-green-400/10 dark:text-green-400 dark:ring-green-400/20'
} as Record<string | number, string>

export const listDaysWeek = [
  'Domingo',
  'Lunes',
  'Martes',
  'Miercoles',
  'Jueves',
  'Viernes',
  'Sabado'
]
export const estructura_odontograma: IEstructuraOdontograma = {
  cuadrante_1: {
    gridArea: 'grid-area:1/1',
    dientes: [
      { diente: 11, gridArea: 'grid-area:1/8' },
      { diente: 12, gridArea: 'grid-area:1/7' },
      { diente: 13, gridArea: 'grid-area:1/6' },
      { diente: 14, gridArea: 'grid-area:1/5' },
      { diente: 15, gridArea: 'grid-area:1/4' },
      { diente: 16, gridArea: 'grid-area:1/3' },
      { diente: 17, gridArea: 'grid-area:1/2' },
      { diente: 18, gridArea: 'grid-area:1/1' }
    ]
  },
  cuadrante_2: {
    gridArea: 'grid-area:1/2',
    dientes: [
      { diente: 21, gridArea: 'grid-area:1/1' },
      { diente: 22, gridArea: 'grid-area:1/2' },
      { diente: 23, gridArea: 'grid-area:1/3' },
      { diente: 24, gridArea: 'grid-area:1/4' },
      { diente: 25, gridArea: 'grid-area:1/5' },
      { diente: 26, gridArea: 'grid-area:1/6' },
      { diente: 27, gridArea: 'grid-area:1/7' },
      { diente: 28, gridArea: 'grid-area:1/8' }
    ]
  },
  cuadrante_3: {
    gridArea: 'grid-area:4/2',
    dientes: [
      { diente: 31, gridArea: 'grid-area:1/1' },
      { diente: 32, gridArea: 'grid-area:1/2' },
      { diente: 33, gridArea: 'grid-area:1/3' },
      { diente: 34, gridArea: 'grid-area:1/4' },
      { diente: 35, gridArea: 'grid-area:1/5' },
      { diente: 36, gridArea: 'grid-area:1/6' },
      { diente: 37, gridArea: 'grid-area:1/7' },
      { diente: 38, gridArea: 'grid-area:1/8' }
    ]
  },
  cuadrante_4: {
    gridArea: 'grid-area:4/1',
    dientes: [
      { diente: 41, gridArea: 'grid-area:1/8' },
      { diente: 42, gridArea: 'grid-area:1/7' },
      { diente: 43, gridArea: 'grid-area:1/6' },
      { diente: 44, gridArea: 'grid-area:1/5' },
      { diente: 45, gridArea: 'grid-area:1/4' },
      { diente: 46, gridArea: 'grid-area:1/3' },
      { diente: 47, gridArea: 'grid-area:1/2' },
      { diente: 48, gridArea: 'grid-area:1/1' }
    ]
  },
  cuadrante_5: {
    gridArea: 'grid-area:2/1',
    dientes: [
      { diente: 51, gridArea: 'grid-area:1/8' },
      { diente: 52, gridArea: 'grid-area:1/7' },
      { diente: 53, gridArea: 'grid-area:1/6' },
      { diente: 54, gridArea: 'grid-area:1/5' },
      { diente: 55, gridArea: 'grid-area:1/4' }
    ]
  },
  cuadrante_6: {
    gridArea: 'grid-area:2/2',
    dientes: [
      { diente: 61, gridArea: 'grid-area:1/1' },
      { diente: 62, gridArea: 'grid-area:1/2' },
      { diente: 63, gridArea: 'grid-area:1/3' },
      { diente: 64, gridArea: 'grid-area:1/4' },
      { diente: 65, gridArea: 'grid-area:1/5' }
    ]
  },
  cuadrante_7: {
    gridArea: 'grid-area:3/2',
    dientes: [
      { diente: 71, gridArea: 'grid-area:1/1' },
      { diente: 72, gridArea: 'grid-area:1/2' },
      { diente: 73, gridArea: 'grid-area:1/3' },
      { diente: 74, gridArea: 'grid-area:1/4' },
      { diente: 75, gridArea: 'grid-area:1/5' }
    ]
  },
  cuadrante_8: {
    gridArea: 'grid-area:3/1',
    dientes: [
      { diente: 81, gridArea: 'grid-area:1/8' },
      { diente: 82, gridArea: 'grid-area:1/7' },
      { diente: 83, gridArea: 'grid-area:1/6' },
      { diente: 84, gridArea: 'grid-area:1/5' },
      { diente: 85, gridArea: 'grid-area:1/4' }
    ]
  }
}
export function getIniciales(
  nombre: string,
  apellido?: string | undefined
): string {
  let iniciales: string | string[]
  if (apellido) {
    iniciales = nombre[0] + apellido[0]
  } else {
    iniciales = nombre.split(' ')
    if (iniciales.length == 1) {
      iniciales = iniciales[0][0].toUpperCase() + iniciales[0][1].toUpperCase()
    } else {
      iniciales = iniciales[0][0].toUpperCase() + iniciales[1][0].toUpperCase()
    }
  }
  return iniciales
}

export function formatearFecha(date: Date) {
  const day = date.getDate()
  const month = date.getMonth() + 1
  const year = date.getFullYear()
  return `${year}/${month}/${day}`
}

export function formatearHora(hora24: string) {
  const [hora, minutos] = hora24.split(':')
  let horaNumero = parseInt(hora, 10)
  const ampm = horaNumero >= 12 ? 'pm' : 'am'
  horaNumero = horaNumero % 12 || 12 // Convertir 0 a 12 para el formato de 12 horas
  const hora12 = horaNumero.toString().padStart(2, '0')
  return `${hora12}:${minutos} ${ampm}`
}

export function horaEstaEntre(
  p_horaCitaIni: Date,
  p_horaCitaFin: Date,
  p_horaInicial: Date,
  p_horaFinal: Date
) {
  return (
    (p_horaCitaIni.getTime() >= p_horaInicial.getTime() &&
      p_horaCitaIni.getTime() < p_horaFinal.getTime()) ||
    (p_horaCitaFin.getTime() > p_horaInicial.getTime() &&
      p_horaCitaFin.getTime() <= p_horaFinal.getTime()) ||
    (p_horaCitaIni.getTime() <= p_horaInicial.getTime() &&
      p_horaCitaFin.getTime() >= p_horaFinal.getTime())
  )
}
export function getCantidadTurno(
  copr_id: number,
  horaInicio: Date,
  horaFin: Date,
  horas: IDispHoras[]
) {
  const citas_medico = horas.filter(cita => cita.copr_id == copr_id)
  if (!citas_medico || citas_medico.length == 0) return 0
  const cita = citas_medico.filter(cita =>
    horaEstaEntre(
      new Date(cita.citt_agendafechainicio as string),
      new Date(cita.citt_agendafechafinal as string),
      horaInicio,
      horaFin
    )
  )
  return cita.length || 0
}
export function generarTurnos(
  fecha: string,
  jornada: IDispAgendas,
  horas: IDispHoras[]
): ITurnos[] {
  const turnos = [] as ITurnos[]
  const horaInicio = new Date(fecha + ' 12:00')
  const horaFin = new Date(fecha + ' 12:00')
  const intervaloMinutos = jornada.cpeh_turnos_hora
  if (!Number.isInteger(intervaloMinutos) || intervaloMinutos <= 0) {
    throw new Error('La jornada tiene un intervalo de turnos inválido')
  }
  horaInicio.setHours(
    Number(jornada.cpeh_hora_inicio.split(':')[0]),
    Number(jornada.cpeh_hora_inicio.split(':')[1]),
    0
  )
  horaFin.setHours(
    Number(jornada.cpeh_hora_final.split(':')[0]),
    Number(jornada.cpeh_hora_final.split(':')[1]),
    0
  )

  let turnoActual = new Date(horaInicio)
  while (turnoActual < horaFin) {
    const horaInicioTurnoDate = new Date(turnoActual)
    const horaFinTurnoDate = new Date(
      turnoActual.getTime() + intervaloMinutos * 60000
    ) // 60000 milisegundos en un minuto
    const inicioTurnoDate = new Date(horaInicioTurnoDate)
    const finTurnoDate = new Date(horaFinTurnoDate)
    const inicioTurno = inicioTurnoDate.toLocaleTimeString(navigator.language, {
      hour: '2-digit',
      minute: '2-digit'
    })
    const finTurno = finTurnoDate.toLocaleTimeString(navigator.language, {
      hour: '2-digit',
      minute: '2-digit'
    })
    const cantidadTurno = getCantidadTurno(
      jornada.copr_id,
      inicioTurnoDate,
      finTurnoDate,
      horas
    )
    turnos.push({
      fecha: {
        objetoInicio: inicioTurnoDate,
        objetoFinal: finTurnoDate,
        citt_agendafechainicio: inicioTurno,
        citt_agendafechafinal: finTurno
      },
      cantidad_citas: cantidadTurno,
      cant_turnos: jornada.cant_turnos,
      cant_desocupada: jornada.cant_turnos - cantidadTurno,
      copr_id: jornada.copr_id,
      empleado: jornada.nombre,
      ocupado: cantidadTurno == jornada.cant_turnos,
      seleccionado: false,
      intervalo: intervaloMinutos,
      loading: false
    })
    turnoActual = horaFinTurnoDate
  }
  return turnos
}

const bloquearRangosPorEvento = (
  rangos: ITurnos[],
  evento: IConfCalendarioAdmin,
  fecha: string
) => {
  if (evento.cocaEsdiacompleto) {
    rangos.forEach(rango => {
      rango.ocupado = true
      rango.cant_desocupada = 0
    })
    return
  }
  if (!evento.cocaHorainicial || !evento.cocaHorafinal) return
  const fechaDia = dayjs(fecha).format('YYYY-MM-DD')
  const horaInicioBloqueo = dayjs(`${fechaDia} ${evento.cocaHorainicial}`)
  const horaFinBloqueo = dayjs(`${fechaDia} ${evento.cocaHorafinal}`)
  rangos.forEach(rango => {
    const inicioTurno = dayjs(rango.fecha.objetoInicio)
    const finTurno = dayjs(rango.fecha.objetoFinal)
    if (
      inicioTurno.isBefore(horaFinBloqueo) &&
      finTurno.isAfter(horaInicioBloqueo)
    ) {
      rango.ocupado = true
      rango.cant_desocupada = 0
    }
  })
}

/**
 * Genera los rangos de disponibilidad de un profesional con las mismas reglas
 * que la grilla de agendamiento: todas las jornadas del día, bloqueos del
 * calendario admin (general o individuales) y marca de cupo lleno.
 */
export function generarRangosDisponibles(
  fecha: string,
  jornadas: IDispAgendas[],
  horasOcupadas: IDispHoras[],
  eventosCalendario: IConfCalendarioAdmin[] = []
): ITurnos[] {
  const rangos = jornadas
    .map(jornada => generarTurnos(fecha, jornada, horasOcupadas))
    .flat()
  const coprId = jornadas[0]?.copr_id
  const eventoGeneral = eventosCalendario.find(ev => !ev.coprId)
  const eventosAplicables = eventoGeneral
    ? [eventoGeneral]
    : eventosCalendario.filter(
        ev =>
          ev.coprId === coprId &&
          dayjs(ev.cocaFechainicial).isSame(dayjs(fecha), 'day')
      )
  eventosAplicables.forEach(ev => bloquearRangosPorEvento(rangos, ev, fecha))
  rangos.forEach(rango => {
    if (rango.cantidad_citas >= rango.cant_turnos) {
      rango.ocupado = true
      rango.cant_desocupada = 0
    }
  })
  return rangos
}
export const validarFechaStringDentroDelRango = (
  fecha1: string,
  fecha2: string,
  fecha3: string,
  fecha4: string
) => {
  const DateFecha1 = new Date(fecha1).getTime()
  const DateFecha2 = new Date(fecha2).getTime()
  const DateFecha3 = new Date(fecha3).getTime()
  const DateFecha4 = new Date(fecha4).getTime()
  return DateFecha1 >= DateFecha4 || DateFecha2 <= DateFecha3
}
export function Unidades(num: number) {
  switch (num) {
    case 1:
      return 'UN'
    case 2:
      return 'DOS'
    case 3:
      return 'TRES'
    case 4:
      return 'CUATRO'
    case 5:
      return 'CINCO'
    case 6:
      return 'SEIS'
    case 7:
      return 'SIETE'
    case 8:
      return 'OCHO'
    case 9:
      return 'NUEVE'
  }

  return ''
} //Unidades()

export function Decenas(num: number) {
  const decena = Math.floor(num / 10)
  const unidad = num - decena * 10

  switch (decena) {
    case 1:
      switch (unidad) {
        case 0:
          return 'DIEZ'
        case 1:
          return 'ONCE'
        case 2:
          return 'DOCE'
        case 3:
          return 'TRECE'
        case 4:
          return 'CATORCE'
        case 5:
          return 'QUINCE'
        default:
          return 'DIECI' + Unidades(unidad)
      }
    case 2:
      switch (unidad) {
        case 0:
          return 'VEINTE'
        default:
          return 'VEINTI' + Unidades(unidad)
      }
    case 3:
      return DecenasY('TREINTA', unidad)
    case 4:
      return DecenasY('CUARENTA', unidad)
    case 5:
      return DecenasY('CINCUENTA', unidad)
    case 6:
      return DecenasY('SESENTA', unidad)
    case 7:
      return DecenasY('SETENTA', unidad)
    case 8:
      return DecenasY('OCHENTA', unidad)
    case 9:
      return DecenasY('NOVENTA', unidad)
    case 0:
      return Unidades(unidad)
  }
} //Unidades()

export function DecenasY(strSin: string, numUnidades: number) {
  if (numUnidades > 0) return strSin + ' Y ' + Unidades(numUnidades)

  return strSin
} //DecenasY()

export function Centenas(num: number) {
  const centenas = Math.floor(num / 100)
  const decenas = num - centenas * 100

  switch (centenas) {
    case 1:
      if (decenas > 0) return 'CIENTO ' + Decenas(decenas)
      return 'CIEN'
    case 2:
      return 'DOSCIENTOS ' + Decenas(decenas)
    case 3:
      return 'TRESCIENTOS ' + Decenas(decenas)
    case 4:
      return 'CUATROCIENTOS ' + Decenas(decenas)
    case 5:
      return 'QUINIENTOS ' + Decenas(decenas)
    case 6:
      return 'SEISCIENTOS ' + Decenas(decenas)
    case 7:
      return 'SETECIENTOS ' + Decenas(decenas)
    case 8:
      return 'OCHOCIENTOS ' + Decenas(decenas)
    case 9:
      return 'NOVECIENTOS ' + Decenas(decenas)
  }

  return Decenas(decenas)
} //Centenas()

export function Seccion(
  num: number,
  divisor: number,
  strSingular: string,
  strPlural: string
) {
  const cientos = Math.floor(num / divisor)
  const resto = num - cientos * divisor

  let letras = ''

  if (cientos > 0)
    if (cientos > 1) letras = Centenas(cientos) + ' ' + strPlural
    else letras = strSingular

  if (resto > 0) letras += ''

  return letras
} //Seccion()

export function Miles(num: number) {
  const divisor = 1000
  const cientos = Math.floor(num / divisor)
  const resto = num - cientos * divisor

  const strMiles = Seccion(num, divisor, 'UN MIL', 'MIL')
  const strCentenas = Centenas(resto)

  if (strMiles == '') return strCentenas

  return strMiles + ' ' + strCentenas
} //Miles()

export function Millones(num: number) {
  const divisor = 1000000
  const cientos = Math.floor(num / divisor)
  const resto = num - cientos * divisor

  const strMillones = Seccion(num, divisor, 'UN MILLON', 'MILLONES')
  const strMiles = Miles(resto)

  if (strMillones == '') return strMiles

  return strMillones + ' ' + strMiles
} //Millones()
interface ICurrency {
  singular: string
  plural: string
  centSingular: string
  centPlural: string
}
export function NumeroALetras(num: number, currency: ICurrency) {
  currency = currency || {}
  const data = {
    numero: num,
    enteros: Math.floor(num),
    centavos: Math.round(num * 100) - Math.floor(num) * 100,
    letrasCentavos: '',
    letrasMonedaPlural: currency.plural || 'PESOS', //'PESOS', 'Dólares', 'Bolívares', 'etcs'
    letrasMonedaSingular: currency.singular || 'PESO', //'PESO', 'Dólar', 'Bolivar', 'etc'
    letrasMonedaCentavoPlural: currency.centPlural || 'CENTAVOS',
    letrasMonedaCentavoSingular: currency.centSingular || 'CENTAVO'
  }

  if (data.centavos > 0) {
    data.letrasCentavos =
      'CON ' +
      (function () {
        if (data.centavos == 1)
          return (
            Millones(data.centavos) + ' ' + data.letrasMonedaCentavoSingular
          )
        else
          return Millones(data.centavos) + ' ' + data.letrasMonedaCentavoPlural
      })()
  }

  if (data.enteros == 0)
    return 'CERO ' + data.letrasMonedaPlural + ' ' + data.letrasCentavos
  if (data.enteros == 1)
    return (
      Millones(data.enteros) +
      ' ' +
      data.letrasMonedaSingular +
      ' ' +
      data.letrasCentavos
    )
  else
    return (
      Millones(data.enteros) +
      ' ' +
      data.letrasMonedaPlural +
      ' ' +
      data.letrasCentavos
    )
}

export const opcionesDate = {
  year: 'numeric' as const,
  month: '2-digit' as const,
  day: '2-digit' as const,
  hour: '2-digit' as const,
  minute: '2-digit' as const,
  hour12: true
}
const yearsDefault: number[] = []
const minYear = 1940
for (let index = minYear; index <= 2090; index++) {
  yearsDefault.push(index)
}

export const years = yearsDefault

export const months = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre'
]

export const getSkeleton = (
  columnas: number,
  filas: number,
  options?: IOptionsSkeleton
) => {
  const anchoC = options?.anchoC || 'width:33%',
    anchoF = options?.anchoF || 'width:95%',
    altoF = options?.altoF || 'h-8'
  const cols: { style: string; lines: IColStyles[] }[] = []
  for (let i = 0; i < columnas; i++) {
    const col: { style: string; lines: IColStyles[] } = {
      style: anchoC,
      lines: []
    }
    for (let i = 0; i < filas; i++) {
      col.lines.push({ style: anchoF, class: altoF })
    }
    cols.push(col)
  }
  return {
    filas: [{ cols: cols }]
  }
}
export const mapDocuments = (documento: IFormComponent[]) => {
  const doc = {
    components: documento
      .filter((e: IFormComponent) => e.typeComponent == 'TAB')
      .map((item: IFormComponent) => {
        item.components = []
        item.components = getComponentsChilds(item.name, documento)
        return item
      })
  } as {
    components: IFormComponent[]
    admision?: ICitaAdmision
    technologia?: ICitaTechnologiasSalud
  }
  return doc
}
const getComponentsChilds = (
  father: string,
  list: IFormComponent[]
): IFormComponent[] => {
  const filtrados = list
    .filter(e => e.componentId == father)
    .map(iterator => {
      iterator.components = [] as IFormComponent[]
      iterator.components = getComponentsChilds(iterator.name, list)
      return iterator
    })
  return filtrados
}
export const desMapDocuments = (
  components: IConfComponents[]
): IConfComponents[] => {
  const desmap: Array<IConfComponents> = []
  getComponents(components, desmap)
  return desmap
}
const getComponents = (
  list: IConfComponents[],
  desmap: IConfComponents[],
  padre: IConfComponents | null = null
) => {
  return list.forEach(item => {
    item.componentId = padre ? padre.name : null
    const newItem = { ...item }
    newItem.components = []
    if (item.typeComponent !== 'LISTA_SQL') {
      desmap.push(newItem as IConfComponents)
    }
    if (item.components) {
      const components = [...item.components]
      getComponents(components, desmap, item)
    }
  })
}
export const formatNumber = (num: string, s?: string) => {
  const separador = '.' // separador para los miles
  const sepDecimal = ',' // separador para los decimales
  const simbol = s || ''
  num += ''
  const splitStr = num.split('.')
  let splitLeft = splitStr[0]
  const splitRight = splitStr.length > 1 ? sepDecimal + splitStr[1] : ''
  const regx = /(\d+)(\d{3})/
  while (regx.test(splitLeft)) {
    splitLeft = splitLeft.replace(regx, '$1' + separador + '$2')
  }
  return simbol + splitLeft + splitRight
}
export const opcionesFormatDate: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }
export const formatearFechaEnEspanol = (fecha: string) => {
  const opciones: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }
  if (fecha.indexOf('T') > -1) {
    const [fechaonly, tiempo] = fecha.split('T')
    return new Date(
      `${fechaonly}T${tiempo ? tiempo.replace('.000Z', '') : '00:00:00'}`
    ).toLocaleString('es-CO', opciones)
  } else {
    const [year, month, day] = fecha.split('-')
    return new Date(
      Number(year),
      Number(month) - 1,
      Number(day)
    ).toLocaleString('es-CO', opciones)
  }
}
export const formatearFechaLarga = (fecha?: string | Date | null, fallback = 'Sin fecha'): string => {
  if (!fecha) return fallback
  const d = new Date(fecha)
  if (isNaN(d.getTime())) return fallback
  return d.toLocaleDateString('es-CO', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  })
}

export const formatearFechaEnEspanolConHora = (fecha: string) => {
  if (!fecha) return 'Invalid Date'
  // Opción base: siempre mostramos fecha
  let opciones: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }

  if (fecha.includes('T')) {
    // Caso con hora -> añadimos hora y minutos
    opciones = {
      ...opciones,
      hour: '2-digit',
      minute: '2-digit',
      hour12: true // cambia a false si prefieres formato 24h
    }
    const fechaObj = new Date(fecha)
    return fechaObj.toLocaleString('es-CO', opciones)
  } else {
    // Caso solo fecha
    const [year, month, day] = fecha.split('-')
    const fechaObj = new Date(Number(year), Number(month) - 1, Number(day))
    return fechaObj.toLocaleDateString('es-CO', opciones)
  }
}

export function getErrores(error: AxiosError) {
  if (error && error.response && 422 == error.response.status) {

    const data = error.response.data as { [key: string]: any }
    return data.errors
  }
  return []
}
export function downloadFile(data: Blob | string, filename: string) {
  const blob =
    typeof data === 'string' ? new Blob([data], { type: 'text/plain' }) : data
  const url = URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()

  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
export function downloadFileByArrayBuffer(data: ArrayBuffer, fileName: string) {
    const blobUrl = URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(blobUrl);
}
export function groupBy<T>(array: T[], keyGetter: (item: T) => string, fieldSort?: string) {
  const map = new Map()
  array.forEach(item => {
    const key = keyGetter(item)
    const collection = map.get(key)
    if (!collection) {
      map.set(key, [item])
    } else {
      collection.push(item)
    }
  })

  // Solo ordenar alfabéticamente las claves si se proporciona fieldSort
  if (fieldSort) {
    // Ordenar las claves alfabéticamente
    const sortedKeys = Array.from(map.keys()).sort()
    const sortedEntries = sortedKeys.map(key => {
      const items = map.get(key)
      // Ordenar los items dentro del grupo por el campo especificado
      if (items) {
        items.sort((a: any, b: any) => {
          const valueA = a[fieldSort]?.toString() || ''
          const valueB = b[fieldSort]?.toString() || ''
          return valueA.localeCompare(valueB)
        })
      }
      return [key, items]
    })
    return Object.fromEntries(sortedEntries)
  } else {
    // Sin ordenamiento, mantener el orden original del Map
    return Object.fromEntries(map)
  }
}
export const sinSimbolos = (value: unknown): boolean => {
  if (typeof value !== 'string' || value.trim() === '') {
    return true
  }
  // eslint-disable-next-line no-control-regex
  const symbolRegex = /[^\u0000-\u00FF]/
  return !symbolRegex.test(value)
}
export const translate = (error: object) => {
  const isArray = Array.isArray(error)
  const errorObject = isArray
    ? (error as object[])[0]

    : (error as any).$errors[0]
  const key = errorObject.$validator
  const params = errorObject.$params
  const translations = {
    required: 'Este campo es obligatorio',
    sinSimbolos: 'No se permiten símbolos, emojis o caracteres especiales',
    email: 'Debe ser un correo válido',
    numeric: 'Debe ser un número',
    minLength: `Debe tener mínimo ${params ? params.min : 0} caracteres`,
    maxLength: `Debe tener máximo ${params ? params.min : 0} caracteres`,
    minValue: 'El valor debe ser mayor a {min}'
  } as Record<string, string>
  return translations[key] || key
}

export const isDateValid = (date: string) => {
  return !isNaN(Date.parse(date))
}

export function restarUnMes(fecha: Date) {
  const nuevaFecha = new Date(fecha)
  const dia = nuevaFecha.getDate()
  nuevaFecha.setMonth(nuevaFecha.getMonth() - 1)
  if (nuevaFecha.getDate() !== dia) {
    nuevaFecha.setDate(0)
  }
  return nuevaFecha
}
export function sumarUnMes(fecha: Date): Date {
  const nuevaFecha = new Date(fecha)
  const dia = nuevaFecha.getDate()
  nuevaFecha.setMonth(nuevaFecha.getMonth() + 1)
  if (nuevaFecha.getDate() !== dia) {
    nuevaFecha.setDate(0)
  }
  return nuevaFecha
}
export function getPageCount(limit: number | string, count: number) {
  return limit.toString() != 'Todos' && typeof limit === 'number'
    ? Math.ceil(count / limit)
    : 1
}
/**
 *
 * @param props
 * @param isArray
 * @returns isError
 */

export function getIsError(props: any, isArray: boolean): boolean {
  const IS_UNDEFINED = props.error == undefined
  const IS_NULL = props.error == null
  const IS_OBJECT = typeof props.error == 'object'
  return (
    !IS_UNDEFINED &&
    !IS_NULL &&
    (!IS_OBJECT ||

      (isArray && (props.error as any).length > 0) ||
      (!isArray &&

        (props.error as any).$errors &&

        (props.error as any).$errors.length > 0))
  )
}


export function getErrorAlert(error: AxiosError) {
  if (error.response?.status == 500) {
    if (
      typeof error.response?.data === 'object' &&
      error?.response?.data !== null
    ) {

      const data = error.response?.data as { [key: string]: any }
      window.notificacion?.report('failure', 'Contactar con soporte.', data.body)
    }
  }
}

export const sortInit = (list: IFormComponent[]) => {
  const result = list.map((item, index: number) => {
    if (item.components) {
      item.components = sortInit(item.components)
    }
    item.orderValue = index + 1
    return item
  })
  return result
}
export const sort = (list: IFormComponent[]) => {
  const result = (list || [])
    .sort((a, b) => (a?.orderValue || 0) - (b?.orderValue || 0))
    .map(item => {
      if (item.components) {
        item.components = sort(item.components)
      }
      return item
    })
  return result
}
export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1)
}
export const mapTabForm = (item: IConfFormxtab | ICitaFormxtab): IFormxtab => {
  return {
    cftaId: (item as ICitaFormxtab).cttaId || undefined,
    cftaIsVisible:
      (item as IConfFormxtab).cftaIsVisible ||
      (item as ICitaFormxtab).cttaIsVisible ||
      true,
    cftaNombre:
      (item as IConfFormxtab).cftaNombre || (item as ICitaFormxtab).cttaNombre,
    cftaOrder:
      (item as IConfFormxtab).cftaOrder !== undefined ? (item as IConfFormxtab).cftaOrder : (item as ICitaFormxtab).cttaOrder,
    components: item.components
  } as IFormxtab
}
/**
 * En preconsulta solo se muestran los componentes marcados con `preForm`.
 *
 * Una sección o contenedor también debe mostrarse cuando ella no está marcada
 * pero sí alguno de sus descendientes: de lo contrario esos campos marcados
 * quedan inalcanzables y la sección se pinta como una caja vacía (era el caso
 * de las secciones múltiples, que salían sin campos).
 */
export const aplicaEnPreconsulta = (comp: IFormComponent): boolean => {
  if (!comp) return false
  if (comp.preForm === true) return true
  return (comp.components || []).some(aplicaEnPreconsulta)
}
export const mapComponentsForm = (
  component: IConfComponents,
  listComponents: IConfComponents[]
): IFormComponent => {
  const components = listComponents.filter(e => e.componentId == component.name).map(item => mapComponentsForm(item, listComponents)) as IFormComponent[]
  component.value = component.value || component.defaultValue
  return {
    ...component,
    components: components
  } as IFormComponent
}
export const removeDuplicatesByName = (components: IFormComponent[]) => {
  const seen = new Set();

  function traverse(list) {
    if (!Array.isArray(list)) return [];

    const result = [] as IFormComponent[];
    for (const comp of list) {
      if (!seen.has(comp.name)) {
        seen.add(comp.name);

        // copiar el componente y limpiar hijos
        const copy = { ...comp };
        if (copy.components && copy.components.length > 0) {
          copy.components = traverse(copy.components);
        }
        result.push(copy);
      } else {
        // si ya fue visto, se descarta junto con sus hijos
        continue;
      }
    }
    return result;
  }

  return traverse(components);
}
export const mapComponentsCita = (
  item: ICitaTabxcomponents
): IFormComponent => {
  if (item.component) {
    /*item.component.properties = JSON.parse(item.component.properties as string)
    item.component.options = item.component.options
      ? JSON.parse(item.component.options as string)
      : []*/
    const itemAny = item
    item.component.value = item.component.typeComponent === 'LISTA_SQL'
      ? null
      : (itemAny as ICitaTabxcomponents).citcValue || item.component?.defaultValue
  }
  return {
    ...item.component,
    orderValue: item.orderValue,
    history: item.history
  } as IFormComponent
}
export function getEntityName(user?: IUserLoged): string {
  if (!user?.entidad) return 'No registrado'
  const listaIPS = JSON.parse(localStorage.getItem('entidades') || '[]') as IConfEntidades[]
  const entidad = listaIPS.find((item) => item.coenCodigo === user.entidad)
  return entidad?.coenNombre || 'No registrado'
}

// Interface para las opciones ampliadas de generación de PDF
export interface IGeneratePdfOptions {
  tipoImpresion: tipoImpresionAsistencialDefault
  isPreview: boolean
  includeGraficas?: boolean
  includeOdontogramas?: boolean
  returnAsBlob?: boolean
}

// Interface para datos ya procesados
export interface IProcessedData {
  components: IFormComponent[]
  technologia: ICitaTechnologiasSalud
  admision: ICitaAdmision
  graficas?: any[]
  odontogramas?: { titulo: string, svg: string }[]
}
export const getStatusClass = (estado: string | undefined) => {
  switch (estado) {
    case 'TRAMITADO':
      return 'bg-green-50 text-green-600 ring-1 ring-inset ring-green-600/10 dark:bg-green-400/10 dark:text-green-400 dark:ring-green-400/20'
    case 'TRAMITADO CON ANEXO':
      return 'bg-blue-50 text-blue-600 ring-1 ring-inset ring-blue-600/10 dark:bg-blue-400/10 dark:text-blue-400 dark:ring-blue-400/20'
    case 'INASISTIDO':
      return 'bg-gray-200 text-gray-800 ring-1 ring-inset ring-gray-800/10 dark:bg-gray-400/10 dark:text-gray-400 dark:ring-gray-400/20'
      case 'ABIERTO':
      return 'bg-amber-50 text-amber-600 ring-1 ring-inset ring-amber-600/10 dark:bg-amber-400/10 dark:text-amber-400 dark:ring-amber-400/20'
    case 'CANCELADO':
      return 'bg-rose-50 text-rose-600 ring-1 ring-inset ring-rose-600/10 dark:bg-rose-400/10 dark:text-rose-400 dark:ring-rose-400/20'
    case 'NO REALIZADO':
      return 'bg-gray-50 text-gray-600 ring-1 ring-inset ring-gray-600/10 dark:bg-gray-400/10 dark:text-gray-400 dark:ring-gray-400/20'
    case 'FINALIZADO':
      return 'bg-green-50 text-green-600 ring-1 ring-inset ring-green-600/10 dark:bg-green-400/10 dark:text-green-400 dark:ring-green-400/20'
    default:
      return 'bg-gray-50 text-gray-600 ring-1 ring-inset ring-gray-600/10 dark:bg-gray-400/10 dark:text-gray-400 dark:ring-gray-400/20'
  }
}
export const getStatusRecetarioClass = (estado: string | undefined) => {
  switch (estado) {
    case 'PENDIENTE':
      return 'bg-rose-50 text-rose-600 ring-1 ring-inset ring-rose-600/10 dark:bg-rose-400/10 dark:text-rose-400 dark:ring-rose-400/20'
      case 'ABIERTO':
      return 'bg-amber-50 text-amber-600 ring-1 ring-inset ring-amber-600/10 dark:bg-amber-400/10 dark:text-amber-400 dark:ring-amber-400/20'
    case 'FINALIZADO':
      return 'bg-green-50 text-green-600 ring-1 ring-inset ring-green-600/10 dark:bg-green-400/10 dark:text-green-400 dark:ring-green-400/20'
    default:
      return 'bg-gray-50 text-gray-600 ring-1 ring-inset ring-gray-600/10 dark:bg-gray-400/10 dark:text-gray-400 dark:ring-gray-400/20'
  }
}

/**
 * Calcula la fecha inicial y final de un turno
 * @param fechaHora Fecha y hora en formato "YYYY-MM-DD HH:MM" o "YYYY-MM-DD HH:MM AM/PM"
 * @param intervaloMinutos Duración del turno en minutos
 */
export function calcularFechaInicialFinalTurno (
  fechaHora: string,
  intervalo: number = 20
) {
  // Normalizar el formato de AM/PM reemplazando "a. m." por "am" y "p. m." por "pm"
  fechaHora = fechaHora.replace(/a\.\s*m\./i, 'am').replace(/p\.\s*m\./i, 'pm')

  try {
    // Si la fechaHora no es una cadena válida, se mostrará un error en la consola y se retornará el rango de fechas actual
    if (!fechaHora || typeof fechaHora !== 'string') {
      console.error(
        'calcularFechaInicialFinalTurno: Fecha/hora inválida',
        fechaHora
      )
      const ahora = new Date()
      return {
        fechaInicial: formatoFecha(ahora),
        fechaFinal: formatoFecha(new Date(ahora.getTime() + intervalo * 60000))
      }
    }

    // Resto de la lógica original de la función
    const soloHora = !fechaHora.includes('-')
    if (soloHora) {
      const hoy = new Date()
      const fechaActual = `${hoy.getFullYear()}-${String(
        hoy.getMonth() + 1
      ).padStart(2, '0')}-${String(hoy.getDate()).padStart(2, '0')}`
      fechaHora = `${fechaActual} ${fechaHora}`
    }
    let fechaInicio: Date

    if (
      fechaHora.toLowerCase().includes('am') ||
      fechaHora.toLowerCase().includes('pm') ||
      fechaHora.toLowerCase().includes('a.m.') ||
      fechaHora.toLowerCase().includes('p.m.')
    ) {
      const [datePart, ...timeParts] = fechaHora.split(' ')
      const timePart = timeParts.join(' ')

      const timeRegex = /(\d{1,2}):(\d{2})(?:\s*)([ap]\.?m\.?)?/i
      const match = timePart.match(timeRegex)

      if (match) {
        const [, hours, minutes, ampm] = match
        let hour24 = parseInt(hours, 10)

        const isPM =
          ampm &&
          (ampm.toLowerCase().startsWith('p') ||
            ampm.toLowerCase().includes('p.m'))
        if (isPM && hour24 < 12) {
          hour24 += 12
        } else if (!isPM && hour24 === 12) {
          hour24 = 0
        }

        const [year, month, day] = datePart.split('-')
        try {
          fechaInicio = new Date(
            parseInt(year, 10),
            parseInt(month, 10) - 1,
            parseInt(day, 10),
            hour24,
            parseInt(minutes, 10)
          )
        } catch (err) {
          console.error(
            'Error al crear objeto Date con partes individuales:',
            err
          )
          fechaInicio = new Date()
        }
      } else {
        console.warn(
          'No se pudo extraer la hora con regex, intentando parseo directo'
        )
        fechaInicio = new Date(fechaHora)
      }
    } else {
      fechaInicio = new Date(fechaHora)
    }

    const fechaParseada = new Date(fechaHora)
    if (isNaN(fechaParseada.getTime())) {
      console.error('La fecha resultante es inválida:', fechaHora)
      return {
        fechaInicial: new Date().toISOString(),
        fechaFinal: new Date().toISOString()
      }
    }

    const fechaFinal = new Date(fechaInicio.getTime() + intervalo * 60000)

    return {
      fechaInicial: formatoFecha(fechaInicio),
      fechaFinal: formatoFecha(fechaFinal)
    }
  } catch (error) {
    console.error('Error al calcular fechas de turno:', error)
    return {
      fechaInicial: new Date().toISOString(),
      fechaFinal: new Date().toISOString()
    }
  }
}


function formatoFecha(fecha: Date): string {
  return `${fecha.getFullYear()}-${String(fecha.getMonth() + 1).padStart(2, '0')}-${String(fecha.getDate()).padStart(2, '0')} ${String(fecha.getHours()).padStart(2, '0')}:${String(fecha.getMinutes()).padStart(2, '0')}`
}

/**
 * Normaliza las variaciones de AM/PM en una cadena de hora.
 * Convierte formatos como "a. m.", "A.M.", " p.m. " a " am" o " pm".
 * También limpia duplicados como " am am" a " am".
 *
 * @param timeString La cadena de hora original.
 * @returns La cadena de hora con AM/PM normalizado.
 */
const normalizeAmPm = (timeString: string): string => {
  let normalized = timeString.replace(
    /\s*([ap])(\s*\.?\s*m\s*\.?)\s*/gi,
    (_, firstLetter) => ` ${firstLetter.toLowerCase()}m`
  )
  let previousValue: string
  do {
    previousValue = normalized
    normalized = normalized.replace(/\s+am\s+am/gi, ' am')
    normalized = normalized.replace(/\s+pm\s+pm/gi, ' pm')
  } while (normalized !== previousValue)
  return normalized.trim()
}

/**
 * Formatea una opción de hora para mostrarla al usuario.
 * Utiliza la interfaz IDispHoras y normaliza el formato AM/PM,
 * opcionalmente añade la cantidad de cupos disponibles.
 *
 * @param item Puede ser una cadena de texto con la hora o un objeto IDispHoras.
 * @returns La cadena de hora formateada.
 */
export const formatHoraOption = (item: IDispHoras | string): string => {
  const horaInicial =
    typeof item === 'string' ? item : String(item.citt_agendafechainicio)
  const horaFormateada = normalizeAmPm(horaInicial)
  if (
    typeof item === 'string' ||
    item.cant_desocupada == null ||
    item.cant_turnos == null
  ) {
    return horaFormateada
  }
  if (item.cant_turnos === 1) return horaFormateada

  return `${horaFormateada} — ${item.cant_desocupada} de ${item.cant_turnos} cupos disponibles`
}

/**
 * Validación de tipo de identificación según la edad
 * @param tipoIdentificacion ID numérico o código corto del tipo de identificación
 * @param fechaNacimiento Fecha de nacimiento en formato YYYY-MM-DD
 * @returns Un objeto con el resultado de la validación
 */
export const validateTypeIdentification = async (
  tipoIdentificacion: number | string,
  fechaNacimiento: string
) => {
  const validation = {
    isValid: true,
    message: ''
  }

  const edadStr = calcularEdad(fechaNacimiento)
  const edad = parseInt(edadStr.split('años,')[0].trim(), 10)

  const codeToRules: Record<string, { min?: number; max?: number; message: string }> = {
    'RC': { // REGISTRO CIVIL
      max: 6,
      message: 'El Registro Civil solo es válido para menores de 7 años.'
    },
    'TI': { // TARJETA DE IDENTIDAD
      min: 7,
      max: 17,
      message: 'La Tarjeta de Identidad es válida solo para personas entre 7 y 17 años.'
    },
    'CC': { // CÉDULA DE CIUDADANÍA
      min: 18,
      message: 'La Cédula de Ciudadanía es válida solo para mayores de 18 años.'
    },
    'CE': { // CÉDULA EXTRANJERÍA
      min: 18,
      message: 'La Cédula de Extranjería es válida solo para mayores de edad.'
    },
    'PA': { // PASAPORTE
      min: 18,
      message: 'El Pasaporte es válido solo para mayores de edad.'
    },
    'MS': { // MENOR SIN IDENTIFICACIÓN
      max: 17,
      message: 'El documento de menor sin identificación es válido solo para menores de edad.'
    },
    'AS': { // ADULTO SIN IDENTIFICACIÓN
      min: 18,
      message: 'El documento de adulto sin identificación es válido solo para mayores de edad.'
    }
  }

  let codigo: string | undefined

  if (typeof tipoIdentificacion === 'number') {
    const { data } = await maestraService.searchByType('TBL_TIPOIDENT')
    const tiposIdentificacion = data.body

    const tipoEncontrado = tiposIdentificacion.find(
      (tipo: IConfMaestra) => tipo.comaId === tipoIdentificacion
    )

    if (tipoEncontrado) {
      codigo = tipoEncontrado.comaNombrecorto
    }
  } else {
    codigo = tipoIdentificacion
  }

  const rule = codigo ? codeToRules[codigo] : undefined

  if (rule) {
    if (
      (rule.min !== undefined && edad < rule.min) ||
      (rule.max !== undefined && edad > rule.max)
    ) {
      validation.isValid = false
      validation.message = rule.message
    }
  }

  return validation
}

export const getEventHandlers = (funciones: IConfCompxfuncion[]): Record<string, (e: Event) => void>   => {
  const handlers: Record<string, (e: Event) => void> = {}
  const grouped = funciones.reduce<Record<string, string[]>>((acc, conf) => {
    if (!acc[conf.coffEvento]) acc[conf.coffEvento] = []
    if (conf.funcion?.cofuScript)
      acc[conf.coffEvento].push(conf.funcion.cofuScript)
    return acc
  }, {})

  for (const [eventName, scripts] of Object.entries(grouped)) {
    handlers[eventName] = (e: Event) => {
      for (const code of scripts) {
        try {
          new Function('e', code)(e)
        } catch (err) {
          console.error('Error ejecutando script dinámico:', err)
        }
      }
    }
  }
  return handlers
}

export async function export_json_to_excel({
  multiHeader = [],
  header,
  data,
  filename = 'export',
  bookType = 'xlsx',
  merges = [],
  autoWidth = true,
  hiddens = [],
  dataValidations = []
}: IExportOptionsAtenciones) {

  function _columnLetterToNumber(letter: string): number {
    let col = 0
    for (let i = 0; i < letter.length; i++) {
      col *= 26
      col += letter.charCodeAt(i) - 64 // A=1, B=2, ...
    }
    return col
  }

  const workbook = new ExcelJS.Workbook()

  for (let i = 0; i < data.length; i++) {
    const sheetName = data[i].sheet || `Sheet${i + 1}`
    const worksheet = workbook.addWorksheet(sheetName)

    const multiHeaderRow =
      multiHeader.find(m => m.sheet === sheetName)?.data || []
    const headerRow = header.find(h => h.sheet === sheetName)?.data || []
    const contentData = data[i].data

    // Agregar multiheader
    for (const row of multiHeaderRow) {
      worksheet.addRow(row)
    }

    // Agregar header principal
    if (headerRow.length) {
      worksheet.addRow(headerRow)
    }

    // Agregar datos
    for (const row of contentData) {
      worksheet.addRow(row)
    }

    if (autoWidth && worksheet.rowCount > 0) {
      const firstRowValues = worksheet.getRow(1).values

      if (Array.isArray(firstRowValues)) {
        worksheet.columns = firstRowValues.map((_, colIndex) => {
          let maxLength = 10
          worksheet.eachRow(row => {
            const cell = row.getCell(colIndex)
            const len = String(cell.value ?? '').length
            if (len > maxLength) maxLength = len
          })
          return { width: maxLength + 2 }
        })
      }
    }


    // Ocultar columnas
    const hiddenCols = hiddens.find(h => h.sheet === sheetName)?.columns || []
    for (const col of hiddenCols) {
      const index = _columnLetterToNumber(col) // ← Corregido
      worksheet.getColumn(index).hidden = true
    }

    // Aplicar merges
    const mergeConfig = merges.find(m => m.sheet === sheetName)?.data || []
    for (const merge of mergeConfig) {
      worksheet.mergeCells(
        merge.s.r + 1,
        merge.s.c + 1,
        merge.e.r + 1,
        merge.e.c + 1
      )
    }

    // Validaciones de datos
    const validations =
      dataValidations.find(v => v.sheet === sheetName)?.data || []
    for (const val of validations) {
      for (let row = 3; row <= 52; row++) {
        worksheet.getCell(row, val.columnNum).dataValidation = {
          type: 'list',
          allowBlank: val.allowBlank,
          formulae: val.lista
        }
      }
    }
  }

  const buffer = await workbook.xlsx.writeBuffer()
  FileSaver.saveAs(
    new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }),
    `${filename}.${bookType}`
  )
}

export const generarExcelPlantilla = async (secciones: IFormComponent[], nombreServicio: string) => {
  const { data: { body: causas } } = await maestraService.searchByType('TBL_TIPOCAUSAEXT');
  const { data: { body: tipodx } } = await maestraService.searchByType('TBL_TIPOSDIAGNOSTICOS');
  const { data: { body: clasedx } } = await maestraService.searchByType('TBL_TIPOSCLASEDX');
  const { data: { body: tipoord } } = await maestraService.searchByType('TBL_TIPOSORDENES');
  const { data: { body: tipoproc } } = await maestraService.searchByType('TBL_TIPOSPROCEDIMIENTOS');

  const data: { sheet: string, data: any[] }[] = ["Historias", "Diagnosticos", "Ordenes", "Recetarios", "Remisiones", "Tipos"].map(name => ({ sheet: name, data: [] }));
  const head: { sheet: string, data: any[], hidden: boolean }[] = ["Historias", "Diagnosticos", "Ordenes", "Recetarios", "Remisiones", "Tipos"].map(name => ({ sheet: name, data: [], hidden: name === 'Tipos' }));
  const multiHeader: { sheet: string, data: any[] }[] = [{ sheet: "Historias", data: [] }];

  const merges: { sheet: string, data: any[] }[] = [{ sheet: "Historias", data: [] }];
  const hiddens = [
    { sheet: "Historias", columns: ['H'], rows: [] },
    { sheet: "Diagnosticos", columns: ['F', 'G'], rows: [] },
    { sheet: "Ordenes", columns: ['G', 'H'], rows: [] }
  ];

  const dataValidations: { sheet: string, data: any[] }[] = ["Historias", "Diagnosticos", "Ordenes", "Recetarios", "Remisiones", "Tipos"].map(name => ({ sheet: name, data: [] }));
  const headerSecciones = ["", "", "", "", "", "", "", ""];
  const campos: string[] = [];

  let cantidadCols = 7;
  let cantidadRowTipos = 2;
  const mergesList: any[] = [];

  dataValidations[0].data.push({ columnNum: 7, lista: [`$H$3:$H$${causas.length + 2}`], allowBlank: false });
  dataValidations[1].data.push({ columnNum: 3, lista: [`$F$2:$F$${tipodx.length + 1}`], allowBlank: false });
  dataValidations[1].data.push({ columnNum: 4, lista: [`$G$2:$G$${clasedx.length + 1}`], allowBlank: false });
  dataValidations[2].data.push({ columnNum: 3, lista: [`$G$2:$G$${tipoord.length + 1}`], allowBlank: false });
  dataValidations[2].data.push({ columnNum: 4, lista: [`$H$2:$H$${tipoproc.length + 1}`], allowBlank: false });

  for (const item of secciones) {
    const cantidadCampos = item.components?.length || 0;
    const colInicio = cantidadCols + 1;
    const colFin = colInicio + cantidadCampos - 1;

    headerSecciones.push(`${item.name} (${item.id})`);
    for (let j = 1; j < cantidadCampos; j++) headerSecciones.push("");

    mergesList.push({ s: { r: 0, c: colInicio }, e: { r: 0, c: colFin } });

    if (Array.isArray(item.components)){
      for (const campo of item.components) {
        let listaValidacion: string[] = []

        if (campo.typeComponent === 'LISTA' && Array.isArray(campo.options)) {
          listaValidacion = campo.options.map(opt =>
            opt.text.replace(',', ' ').split(';')[1]?.trim()
          )
        } else if (
          campo.typeComponent === 'SI/NO' &&
          Array.isArray(campo.options)
        ) {
          const optionsString = campo.options.join('')
          listaValidacion = optionsString
            .replace(',', ' ')
            .replace(';', ',')
            .split(',')
            .map(v => v.trim())
        }

        if (listaValidacion.length > 0) {
          data[5].data.push([cantidadCols + 1])
          const inicio = cantidadRowTipos

          listaValidacion.forEach(val => data[5].data.push([val]))

          cantidadRowTipos += listaValidacion.length

          dataValidations[0].data.push({
            columnNum: cantidadCols + 1,
            lista: [`Tipos!$A$${inicio + 1}:$A$${cantidadRowTipos}`],
            allowBlank: campo.required !== true
          })

          cantidadRowTipos++
        }

        campos.push(
          `${campo.label}${campo.required ? ' (*)' : ''}(${campo.typeComponent || ''})(${campo.componentId})`
        )
        cantidadCols++
      }
    }

  }

  multiHeader[0].data = [headerSecciones];
  head[0].data = ["ITEM", "PROFESIONAL", "PACIENTE", "FECHA", "HORA ATENCION", "HORA FIN ATENCION", "CAUSA EXTERNA", "TIPOS CAUSA EXTERNA", ...campos];
  head[1].data = ["ITEM", "CIE10", "TIPO", "CLASE", "OBSERVACION", "TIPOS DX", "CLASE DX"];
  head[2].data = ["ITEM", "CUPS", "TIPO DE ORDEN", "TIPO DE PROCEDIMIENTO", "CANTIDAD", "OBSERVACIONES", "TIPOS ORDEN", "TIPOS PROC"];
  head[3].data = ["ITEM", "MEDICAMENTO", "FRECUENCIA DE HORAS", "DIAS", "DOSIS", "CANTIDAD", "DETALLE"];
  head[4].data = ["ITEM", "CUPS", "OBSERVACIONES"];
  head[5].data = ["TIPOS"];
  merges[0].data = mergesList;

  const colsNum = cantidadCols;
  for (let i = 0; i < 50; i++) {
    const filaHistoria = new Array(colsNum + 1).fill("");
    if (causas[i]) filaHistoria[7] = causas[i].comaNombrelargo;
    data[0].data.push(filaHistoria);

    const filaDx = new Array(7).fill("");
    if (tipodx[i]) filaDx[5] = tipodx[i].comaNombrelargo;
    if (clasedx[i]) filaDx[6] = clasedx[i].comaNombrelargo;
    data[1].data.push(filaDx);

    const filaOrd = new Array(8).fill("");
    if (tipoord[i]) filaOrd[6] = tipoord[i].comaNombrelargo;
    if (tipoproc[i]) filaOrd[7] = tipoproc[i].comaNombrelargo;
    data[2].data.push(filaOrd);
  }

  export_json_to_excel({
    header: head,
    data,
    filename: `PLANTILLA - ${nombreServicio}`,
    bookType: 'xlsx',
    multiHeader,
    merges,
    hiddens,
    dataValidations
  });
};

/**
 * Formatea una fecha usando dayjs con zona horaria y formato configurables.
 * @param date Fecha a formatear (Date, string, o number)
 * @param format Formato de salida (por defecto: 'YYYY-MM-DD 00:00:00')
 * @param zone Zona horaria (por defecto: 'America/Bogota')
 * @returns string Fecha formateada
 */
export function formatDateWithDayjsZone(
  date: Date | string | number,
  format: string = 'YYYY-MM-DD HH:mm:ss',
  zone: string = 'America/Bogota'
): string {
  return dayjs.tz(date, zone).format(format)
}

export const formatFileSize = size => {
    if (size < 1024) {
        return size + ' bytes'
    } else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + ' KB'
    } else {
        return (size / (1024 * 1024)).toFixed(2) + ' MB'
    }
}

/**
 * Genera un UUID v4 funcionando en CUALQUIER contexto.
 *
 * `crypto.randomUUID()` SOLO existe en contextos seguros (HTTPS o localhost).
 * En despliegues servidos por HTTP plano sobre IP —p.ej. http://192.168.6.205:30080—
 * el navegador no lo expone y cualquier `setup()` que lo llame revienta con
 * "crypto.randomUUID is not a function".
 *
 * `crypto.getRandomValues` SI esta disponible en contextos no seguros, asi que se
 * usa como respaldo manteniendo calidad criptografica. El ultimo recurso
 * (Math.random) solo aplicaria si no existiera Web Crypto del todo.
 */
export function generarUuid (): string {
  const cryptoObj = globalThis.crypto

  if (typeof cryptoObj?.randomUUID === 'function') {
    return cryptoObj.randomUUID()
  }

  if (typeof cryptoObj?.getRandomValues === 'function') {
    const bytes = cryptoObj.getRandomValues(new Uint8Array(16))
    bytes[6] = (bytes[6] & 0x0f) | 0x40 // version 4
    bytes[8] = (bytes[8] & 0x3f) | 0x80 // variante RFC 4122
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

/**
 * Copia al portapapeles con respaldo para contextos NO seguros.
 * `navigator.clipboard` tambien es exclusivo de contextos seguros (HTTPS o
 * localhost); en HTTP plano queda undefined y el boton de copiar falla.
 * El respaldo usa el viejo `document.execCommand('copy')`, que sigue soportado.
 */
export const copiarAPortapapeles = async (valor: string): Promise<boolean> => {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(valor)
      return true
    }
  } catch {
    // cae al respaldo
  }
  try {
    const area = document.createElement('textarea')
    area.value = valor
    area.setAttribute('readonly', '')
    area.style.position = 'fixed'
    area.style.opacity = '0'
    document.body.appendChild(area)
    area.select()
    const ok = document.execCommand('copy')
    document.body.removeChild(area)
    return ok
  } catch {
    return false
  }
}

export const parseDocDefinition = (code) => {
  // fuerza a ser una expresión que retorna un objeto
  const wrapped = `"use strict";\nreturn (${code});`;
  const factory = new Function(wrapped);
  const result = factory();
  if (!result || typeof result !== 'object') throw new Error('El código no devolvió un objeto');
  if (!Array.isArray(result.content)) throw new Error('docDefinition inválido: falta "content"');
  return result;
}
export const parseJS = (code) => {
  // fuerza a ser una expresión que retorna un objeto
  const wrapped = `"use strict";\nreturn (${code});`;
  const factory = new Function(wrapped);
  const result = factory();
  if (!result || typeof result !== 'object') throw new Error('El código no devolvió un objeto');
  return result;
}
export const setItemConExpiracion = (clave: string, valor: string, minutos: number) => {
  const ahora = new Date();
  const item = {
    valor,
    expiracion: ahora.getTime() + minutos * 60000,
  };
  localStorage.setItem(clave, JSON.stringify(item));
}

// Obtener y validar expiración
export const getItemConExpiracion = (clave: string) => {
  const itemStr = localStorage.getItem(clave);
  if (!itemStr) return null;

  const item = JSON.parse(itemStr);
  const ahora = new Date();

  if (ahora.getTime() > item.expiracion) {
    localStorage.removeItem(clave);
    return null;
  }

  return item.valor;
}

export const getCompontInChildrens = (comp: IFormComponent, codigo: string): IFormComponent | undefined => {
  const directo = comp.components?.find(e => e.name === codigo)
  if (directo) return directo
  for (const hijo of comp.components ?? []) {
    const encontrado = getCompontInChildrens(hijo, codigo)
    if (encontrado) return encontrado
  }
}

export function validateOrdersBeforeClear(technologia: ICitaTechnologiasSalud): boolean {
  if (technologia?.ordenestecnologia) {
    const hasManagedOrders = technologia.ordenestecnologia.some(orden =>
      orden.detalles?.some(detalle =>
        (detalle.origenesAdmisiones && detalle.origenesAdmisiones.length > 0) ||
        (detalle.origenesAgendamientos && detalle.origenesAgendamientos.length > 0)
      )
    )

    if (hasManagedOrders) {
      return false
    }
  }
  return true
}

// Conserva el día de Colombia; las fechas sin zona usan el desfase de origen indicado.
export function normalizarFechaSinHora(fecha?: string | null, desfaseOrigen = '-05:00'): string {
  if (!fecha) return ''
  if (/^\d{4}-\d{2}-\d{2}$/.test(fecha)) return fecha
  const tieneZona = /(?:Z|[+-]\d{2}:\d{2})$/i.test(fecha)
  const fechaUtc = new Date(fecha.replace(' ', 'T') + (tieneZona ? '' : desfaseOrigen))
  return Number.isNaN(fechaUtc.getTime()) ? '' : formatDateWithDayjsZone(fechaUtc, 'YYYY-MM-DD', 'America/Bogota')
}

export function formatearFechaISO(date: Date): string {
  const yyyy = date.getFullYear()
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')
  return `${yyyy}-${mm}-${dd}`
}

export const agregarHoraActual = (fecha?: string | null): string => {
  const ahora = new Date()
  const horas = String(ahora.getHours()).padStart(2, '0')
  const minutos = String(ahora.getMinutes()).padStart(2, '0')
  return `${fecha} ${horas}:${minutos}`
}

export function formatearFechaCorta(fecha?: string | Date | null, fallback = ''): string {
  if (!fecha) return fallback
  const esSoloFecha = typeof fecha === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(fecha)
  const d = esSoloFecha ? new Date(`${fecha}T00:00:00`) : new Date(fecha)
  if (isNaN(d.getTime())) return fallback
  return d.toLocaleDateString('es-CO', { day: '2-digit', month: 'short', year: 'numeric' })
}
